import { useState } from 'react';
import { usePrefixCls } from 'src/hook/useConfig';
import './login.scss';
import LoginForm from './loginForm';
import LocaleMode from '../layout/components/header/localeMode';
import { useLocale } from '../../locales';
const Login = () => {
  const prefixCls = usePrefixCls('login');
  const { getFormatText } = useLocale();
  const [formActive] = useState('login');
  function renderForm() {
    const isLogin: boolean = formActive === 'login';
    const loginAnimate = isLogin
      ? 'animate__fadeInRight'
      : 'animate__fadeOutRight';
    const loginForm = (
      <div
        className={
          `flex flex-row align-midden justify-center animate__animated ` +
          loginAnimate
        }
        style={{ flex: 1 }}
      >
        <LoginForm />
      </div>
    );
    return <>{loginForm}</>;
  }
  return (
    <div className={prefixCls}>
      {/* 背景渐变层 */}
      <div className={`${prefixCls}-background`}></div>

      {/* 顶部工具栏 */}
      <div className={`${prefixCls}-header`}>
        {/* <ColorMode /> */}
        <LocaleMode />
      </div>

      {/* 主要内容区域 */}
      <div className={`${prefixCls}-container`}>
        {/* 标题 */}
        <div className={`${prefixCls}-title`}>
          <h1>{getFormatText('web.login.welcome')}</h1>
          <p>{getFormatText('web.login.tagline')}</p>
        </div>

        {/* 登录卡片 */}
        <div className={`${prefixCls}-card`}>
          {/* 登录方式切换 */}
          {/* <div className={`${prefixCls}-tabs`}>
            <div className={`${prefixCls}-tab active`}></div>
            <div className={`${prefixCls}-tab`}>验证码登录</div>
          </div> */}

          {/* 登录表单 */}
          <div className={`${prefixCls}-form`}>{renderForm()}</div>
        </div>
      </div>
    </div>
  );
};

export default Login;
